var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.75C9.7165 13.75 10.5 12.9665 10.5 12C10.5 11.0335 9.7165 10.25 8.75 10.25C7.7835 10.25 7 11.0335 7 12C7 12.9665 7.7835 13.75 8.75 13.75Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.75C9.7165 6.75 10.5 5.9665 10.5 5C10.5 4.0335 9.7165 3.25 8.75 3.25C7.7835 3.25 7 4.0335 7 5C7 5.9665 7.7835 6.75 8.75 6.75Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20.75C9.7165 20.75 10.5 19.9665 10.5 19C10.5 18.0335 9.7165 17.25 8.75 17.25C7.7835 17.25 7 18.0335 7 19C7 19.9665 7.7835 20.75 8.75 20.75Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.75C16.2165 13.75 17 12.9665 17 12C17 11.0335 16.2165 10.25 15.25 10.25C14.2835 10.25 13.5 11.0335 13.5 12C13.5 12.9665 14.2835 13.75 15.25 13.75Z",
    fill: "#495057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 6.75C16.2165 6.75 17 5.9665 17 5C17 4.0335 16.2165 3.25 15.25 3.25C14.2835 3.25 13.5 4.0335 13.5 5C13.5 5.9665 14.2835 6.75 15.25 6.75Z",
    fill: "#495057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 20.75C16.2165 20.75 17 19.9665 17 19C17 18.0335 16.2165 17.25 15.25 17.25C14.2835 17.25 13.5 18.0335 13.5 19C13.5 19.9665 14.2835 20.75 15.25 20.75Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.673ca30da83d40cb72ac81feed602ed2.svg";
export { ForwardRef as ReactComponent };